const name = 'characteristics';

export const GET_CHARACTERISTICS_LIST_REQUEST = `${name}/GET_CHARACTERISTICS_LIST_REQUEST`;
export const GET_CHARACTERISTICS_LIST_SUCCESS = `${name}/GET_CHARACTERISTICS_LIST_SUCCESS`;
export const GET_CHARACTERISTICS_LIST_FAILURE = `${name}/GET_CHARACTERISTICS_LIST_FAILURE`;

export const GET_CHARACTERISTICS_DETAILS_REQUEST = `${name}/GET_CHARACTERISTICS_DETAILS_REQUEST`;
export const GET_CHARACTERISTICS_DETAILS_SUCCESS = `${name}/GET_CHARACTERISTICS_DETAILS_SUCCESS`;
export const GET_CHARACTERISTICS_DETAILS_FAILURE = `${name}/GET_CHARACTERISTICS_DETAILS_FAILURE`;

export const UPDATE_CHARACTERISTICS_DETAILS_REQUEST = `${name}/UPDATE_CHARACTERISTICS_DETAILS_REQUEST`;
export const UPDATE_CHARACTERISTICS_DETAILS_SUCCESS = `${name}/UPDATE_CHARACTERISTICS_DETAILS_SUCCESS`;
export const UPDATE_CHARACTERISTICS_DETAILS_FAILURE = `${name}/UPDATE_CHARACTERISTICS_DETAILS_FAILURE`;

export default name;
